// extracted by mini-css-extract-plugin
export var centerText = "_es-8";
export var container = "_es-0";
export var doughnutContainer = "_es-7";
export var legend = "_es-a";
export var legendItemColorDisplay = "_es-b";
export var legendItemLabel = "_es-d";
export var legendItemValue = "_es-c";
export var lg = "_es-5";
export var maxWidth = "_es-9";
export var md = "_es-4";
export var responsive = "_es-6";
export var sm = "_es-3";
export var xs = "_es-2";
export var xxs = "_es-1";